module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-message', {
    attrs: {
      "title": "Info",
      "type": "is-info",
      "aria-close-label": "Close message"
    }
  }, [_vm._v("\n    Для того, чтобы выгрузить детализированный отчёт по кампании необходимо выбрать стартовую и конечную даты,\n    кампанию и нажать \"Отправить запрос\".\n    По готовности отчёта будет отправлено письмо. Так же результат можно будет посмотреть в релевантной карточке\n    детализации на данной странице.\n  ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select start period date"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "max-date": _vm.getCurrentDate()
    },
    model: {
      value: (_vm.startPeriodDate),
      callback: function($$v) {
        _vm.startPeriodDate = $$v
      },
      expression: "startPeriodDate"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select end period date"
    }
  }, [_c('b-datepicker', {
    attrs: {
      "rounded": "",
      "size": "is-medium",
      "placeholder": "Click to select...",
      "max-date": _vm.getCurrentDate()
    },
    model: {
      value: (_vm.endPeriodDate),
      callback: function($$v) {
        _vm.endPeriodDate = $$v
      },
      expression: "endPeriodDate"
    }
  })], 1), _vm._v(" "), (_vm.campaignsList) ? _c('b-field', {
    attrs: {
      "label": "Campaign"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a campaign",
      "rounded": "",
      "required": "",
      "expanded": "",
      "size": "is-medium"
    },
    model: {
      value: (_vm.selectedCampaign),
      callback: function($$v) {
        _vm.selectedCampaign = $$v
      },
      expression: "selectedCampaign"
    }
  }, _vm._l((_vm.campaignsList), function(campaign) {
    return _c('option', {
      key: campaign.id,
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n        " + _vm._s(campaign.name) + "\n      ")])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !!_vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.sendGenerateDetailsReportRequest()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Отправить запрос")])])]), _vm._v(" "), (_vm.detailsReportsPage && _vm.detailsReportsPage.content) ? _c('div', {
    staticClass: "reports-container"
  }, [_vm._l((_vm.detailsReportsPage.content), function(detailsReport) {
    return _c('div', {
      key: detailsReport.id,
      staticClass: "report-card"
    }, [_c('div', {
      staticClass: "report-card-title"
    }, [_c('h2', [_vm._v(" №" + _vm._s(detailsReport.id) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "report-card-status",
      class: _vm.getStatusClass(detailsReport.status)
    }, [_vm._v(_vm._s(detailsReport.status))])]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details"
    }, [_c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Кампания : " + _vm._s(detailsReport.campaignName) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Начало периода выгрузки : " + _vm._s(detailsReport.startDatePeriod) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Конец периода выгрузки : " + _vm._s(detailsReport.endDatePeriod) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Дата создания запроса : " + _vm._s(_vm.getDateFormat((detailsReport.createdTimestamp / 1000) < 1000000000000 ? detailsReport.createdTimestamp : detailsReport.createdTimestamp / 1000)) + "\n        ")]), _vm._v(" "), (detailsReport.finishedTimestamp) ? _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Запрос обработан : " + _vm._s(_vm.getDateFormat((detailsReport.finishedTimestamp / 1000) < 1000000000000 ? detailsReport.finishedTimestamp : detailsReport.finishedTimestamp / 1000)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "report-card-details-item"
    }, [_vm._v("\n          Прогресс выполнения отчёта :\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "report-card-progress"
    }, [_c('b-progress', {
      attrs: {
        "size": "is-large",
        "type": _vm.getProgressType(detailsReport.progress),
        "value": detailsReport.progress,
        "show-value": "",
        "format": "percent"
      }
    })], 1), _vm._v(" "), (detailsReport.status === 'SUCCESS') ? _c('a', {
      staticClass: "report-card-button",
      attrs: {
        "target": "_blank",
        "rel": "noopener noreferrer",
        "href": detailsReport.hostPathToReport
      }
    }, [_vm._v(" Скачать отчёт ")]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadDetailsReportsPage,
      "per-page": _vm.perPage,
      "data": _vm.detailsReportsPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.detailsReportsPage = $event
      }
    }
  })], 1)], 2) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c1fb2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/billing/BillingDetails.vue
// module id = 388
// module chunks = 42